import camelCase from 'lodash-es/camelCase';
import upperFirst from 'lodash-es/upperFirst';

const baseComponents = import.meta.glob('../components/Base*.vue', {
  eager: true,
});
const componentFolders = import.meta.glob('../components/base-*/index.vue', {
  eager: true,
});
const layoutComponents = import.meta.glob('../components/layout/*.vue', {
  eager: true,
});

const componentsData = [
  ...Object.entries(baseComponents),
  ...Object.entries(layoutComponents),
].map(([path, definition]) => ({
  name: path
    ?.split('/')
    ?.pop()
    ?.replace(/\.\w+$/, ''),
  config: definition.default,
}));

Object.entries(componentFolders).forEach(([path, definition]) => {
  componentsData.push({
    name: upperFirst(camelCase(path.split('/')[2])),
    config: definition.default,
  });
});

export default componentsData;
